import { Box, Text, VStack } from "@chakra-ui/react";
import React from "react";

export function FilesToExport({
  dataSourceName,
  children,
}: {
  dataSourceName: string;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <Box>
      <Text as="h3">Recommended files</Text>
      <Text fontSize="sm" mb={2}>
        Export these files{dataSourceName ? ` from ${dataSourceName}` : ""},
        then import them into Syla.
      </Text>

      <VStack align="stretch" spacing={2}>
        {children}
      </VStack>
    </Box>
  );
}
